import SelectLang from '../../components/SelectLang';

import "./style.css";

function Planning() {

    return (
        <div className='page page_planning'>
            <span className='title_page'>
                - Planning -
            </span>

            <SelectLang />
        </div>
    );
}

export default Planning;